<div class=" bg-body-tertiary">
  <div class=" text-center ">
    <div class="container py-5">
      <span class="fs-1 fw-medium textSecondary ">Comprometidos con
        <span class="fw-bolder ">tu salud</span>
      </span>
      <br>
      <span class=" fs-4 fw-medium text-secondary">
        Contamos con servicios médicos para que tus
      <br>
      requerimientos de salud estén en un solo lugar.</span>
    </div>





    <div class="row d-flex mx-auto justify-content-center align-items-center   w-75">

      <div class="col-lg-4 py-4 ">
        <div class="card mx-auto" style="width: 15rem; height: 16rem">
          <div class="card-body mt-1">
            <img ngSrc="assets/img/home/MoviLink.svg" alt="terapiaFisica" class=" flex-shrink-0" height="60"
                 width="90">
            <div class="container mt-3 lh-sm">
              <p class="card-text fw-bold fs-5  textSecondary  mt-3 mb-1">MoviLink</p>

              <div class="container ">

                <span class=" fw-normal fs-6 lh-1 text-secondary ">Servicios médicos <br> <span class="fw-bold text-secondary  ">en casa </span> </span>
              </div>

            </div>
            <div class="container mt-3 mx-auto">

              <button routerLink="/movilink" class="text-secondary card-link fs-6 text-light textPrimaryColor" >Más información</button>
            </div>

          </div>
        </div>
      </div>
      <div class="col-lg-4 py-4 ">
        <div class="card mx-auto" style="width: 15rem; height: 16rem">
          <div class="card-body mt-1">
            <img ngSrc="assets/img/home/terapiaFisica.svg" alt="terapiaFisica" class=" flex-shrink-0" height="60"
                 width="90">
            <div class="container mt-3 lh-sm">
              <p class="card-text fw-bold fs-5  textSecondary  mt-3 mb-1">Terapia Física</p>

              <div class="container ">

                <span class=" fw-normal fs-6 lh-1 text-secondary ">Vive sin <br> <span class="fw-bold  "> limitaciones </span> </span>
              </div>

            </div>
            <div class="container mt-3 mx-auto">

              <a routerLink="/terapiafisica" class="text-light card-link fs-6 amarrilloMedilink" >¡Lo necesito!</a>
            </div>

          </div>
        </div>
      </div>
      <div class="col-lg-4 py-4 ">
        <div class="card mx-auto" style="width: 15rem; height: 16rem">
          <div class="card-body mt-1">
            <img ngSrc="assets/img/home/OnLink.svg" alt="OnLink" class=" flex-shrink-0" height="60"
                 width="90">
            <div class="container mt-3 lh-sm">
              <p class="card-text fw-bold fs-5  textSecondary  mt-3 mb-1">OnLink</p>

              <div class="container ">

                <span class=" fw-normal fs-6 lh-1 text-secondary ">Consulta médica <br> <span class="fw-bold  "> en línea </span> </span>
              </div>
            </div>
            <div class="container mt-3 mx-auto">

              <button routerLink="/onlink" class="card-link fs-6">Agendar Consulta</button>
            </div>

          </div>
        </div>
      </div>
    </div>



  </div>

</div>
